<div class="av-full-card-summary" fxLayout="row" fxLayout.lt-sm="column">
    <ng-content></ng-content>
</div>
